import { inject, injectable } from "@launchtray/tsyringe-async";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { IStealController } from "./IStealController";
import { StealCard } from "../../../game/flow/impl/diceActions/stealAction/StealCard";
import { INetworkClient } from "../../../../networking/INetworkClient";

@injectable()
export class StealController implements IStealController {
    private readonly networkClient: INetworkClient;
    private readonly playerModel: IPlayerModel;

    public constructor(
        @inject("INetworkClient") networkClient: INetworkClient,
        @inject("IPlayerModel") playerModel: IPlayerModel
    ) {
        this.networkClient = networkClient;
        this.playerModel = playerModel;
    }

    public async getStealCardData(): Promise<Array<StealCard>> {
        const stealCardsResult = await this.networkClient.getStealActionCards();
        if (stealCardsResult.items == undefined || stealCardsResult.items.length < 6) {
            throw new Error(`Failed to create StealAction with stealCards.`);
        }
        const stealCards = [];
        for (const stealCardDto of stealCardsResult.items) {
            stealCards.push(new StealCard(stealCardDto));
        }
        return stealCards;
    }

    public collectCoins(value: number): void {
        this.playerModel.addCoins(value);
    }
}
